var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.loading)?_c('f-loading',{attrs:{"loading":_vm.loading,"fullscreen":""}}):_vm._e(),_c('f-panel',{staticClass:"scheme-introdution body-2",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }